import { memo, useEffect } from 'react'
import { usePlanningRecordDialog } from '../../providers/PlanningRecordDialogProvider'
import { useParams } from 'react-router-dom'

const PlanningRecordPage = () => {
  const { planningRecordId } = useParams<{ planningRecordId: string }>()
  const { openPlanningRecordDialog, closePlanningRecordDialog } = usePlanningRecordDialog({
    planningRecordId: planningRecordId as string,
  })
  useEffect(() => {
    openPlanningRecordDialog()
    return () => {
      closePlanningRecordDialog()
    }
  })
  return null
}

export default memo(PlanningRecordPage)
